import classnames from "classnames";
import React, { Component } from "react";
import ReactLoading from "react-loading";
import { connect } from "react-redux";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row
} from "reactstrap";
import onBoarding from "../../files/ic_on_boarding.png";
import SelectationTab from "./SelectationTab";
import OnBoardingCCMList from "./OnBoardingCCMList";
const _ = require("lodash");
class OnBoardingCCM extends Component {
  constructor(props) {
    super(props);    
    this.state = {
      activeTab: "1",
      onDisplayAllCcmOnboarding: true,
      onDisplayNeedToRequestCCMOrderFromProvider: false,
      onDisplayRequestedCCMOrderFromProvider: false, 
      loading: true,
      catagoryID: undefined
    };
  }
  
  componentDidMount() {
    this.props.dispatch({
      type: "DO_GET_ALL_DEVICE"
    });
    this.onFetchReadingCount();    
  }
  onFetchReadingCount(){
    this.props.dispatch({
      type: "DO_GET_ON_BOARDING_CCM_COUNT"
    });
  }

  onDisplayAllCcmOnboarding() {
    this.onFetchReadingCount();        
    this.setState({
      onDisplayAllCcmOnboarding: true,
      onDisplayNeedToRequestCCMOrderFromProvider: false,
      onDisplayRequestedCCMOrderFromProvider: false,     
      catagoryID: undefined
    }, () => {
      this.fetchData();
    });
  }

  onDisplayNeedToRequestCCMOrderFromProvider() {
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAllCcmOnboarding: false,
      onDisplayNeedToRequestCCMOrderFromProvider: true,
      onDisplayRequestedCCMOrderFromProvider: false,
      catagoryID: "65081c5b4e8e9173654eb40b"
    }, () => {
      this.fetchData();
    });
  }
  // Requested CCM Order from Provider
  onDisplayRequestedCCMOrderFromProvider() {
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAllCcmOnboarding: false,
      onDisplayNeedToRequestCCMOrderFromProvider: false,
      onDisplayRequestedCCMOrderFromProvider: true,  
      catagoryID: "65081cba4e8e9173654eb40c"
    }, () => {
      this.fetchData();
    });
  }

  render() {
    const isMobile = window.innerWidth <= 768;       
    var mAllCCMOnBoarding = { backgroundColor: "#198ae3", color: "white" };     
    var mNeedToRequestCCMOrderFromProvider = { backgroundColor: "white", color: "black" };
    var mRequestedCCMOrderFromProvider = { backgroundColor: "white", color: "black" };     
    
    if (this.state.onDisplayNeedToRequestCCMOrderFromProvider) {
      // Display Requested RPM
      mAllCCMOnBoarding = { backgroundColor: "white", color: "black" };
      mNeedToRequestCCMOrderFromProvider = { backgroundColor: "#198ae3", color: "white" };
      mRequestedCCMOrderFromProvider = { backgroundColor: "white", color: "black" };      
    } else if (this.state.onDisplayRequestedCCMOrderFromProvider) {
      // Display Pre Shipment
      mAllCCMOnBoarding = { backgroundColor: "white", color: "black" };
      mNeedToRequestCCMOrderFromProvider = { backgroundColor: "white", color: "black" };
      mRequestedCCMOrderFromProvider = { backgroundColor: "#198ae3", color: "white" };      
    }
    return (
      <div>
        <div className="row">
          <div className="col-12 grid-margin">          
            <div className="card">
              <div className="card-body project-tab pt-2">
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                      <img className="img-tabsfluid" src={onBoarding} style={{marginRight:5}}/>
                      CCM On-Boarding
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row>
                  <Col sm="12" className="grid-margin mt-4 remove-pading-table">
                    {!this.state.loading && (
                      <ReactLoading className="mx-auto" color={"#007bff"} />
                    )}
                    {this.state.loading && (
                      <Row  style={{marginLeft : '7px', marginRight : '7px'}}>
                        <Col xs={12} sm={6} md={4} className="mt-4 mb-2" style={!isMobile ? { flex: '1', paddingLeft: '4px', paddingRight: '4px' } : {}}>
                          {" "}
                          <div
                            className="card overflow-hidden card-design"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.onDisplayAllCcmOnboarding()
                            }
                          >
                            <SelectationTab
                              title={"All Patients"}
                              displayCount={this.props.onBoardingCCM && this.props.onBoardingCCM.mAllCCMOnBoardingSize ? this.props.onBoardingCCM.mAllCCMOnBoardingSize : 0}
                              style={mAllCCMOnBoarding}
                              />
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={4} className="mt-4 mb-2" style={!isMobile ? { flex: '1', paddingLeft: '4px', paddingRight: '4px' } : {}}>
                          {" "}
                          <div
                            className="card overflow-hidden card-design"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.onDisplayNeedToRequestCCMOrderFromProvider()
                            }
                          >
                            <SelectationTab
                              title={"Requested CCM Order from Provider"}
                              displayCount={this.props.onBoardingCCM && this.props.onBoardingCCM.mNeedToRequestCCMOrderFromProviderSize ? this.props.onBoardingCCM.mNeedToRequestCCMOrderFromProviderSize : 0}
                              style={mNeedToRequestCCMOrderFromProvider}
                              />
                          </div>
                        </Col>

                        <Col xs={12} sm={6} md={4} className="mt-4 mb-2" style={!isMobile ? { flex: '1', paddingLeft: '4px', paddingRight: '4px' } : {}}>
                          {" "}
                          <div
                            className="card overflow-hidden card-design"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.onDisplayRequestedCCMOrderFromProvider()
                            }
                          >
                            <SelectationTab
                              title={"Need to Update Patient’s Profile"}
                              displayCount={this.props.onBoardingCCM && this.props.onBoardingCCM.mRequestedCCMOrderFromProviderSize ? this.props.onBoardingCCM.mRequestedCCMOrderFromProviderSize : 0}
                              style={mRequestedCCMOrderFromProvider}
                              />
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <OnBoardingCCMList
                      fetchDataFromServer={click => this.fetchData = click}
                      catagoryID={this.state.catagoryID}
                      profileOwner={this.props.profileOwner}
                      userId={this.props.userId}
                    />
                </Row>                
              </div>
            </div>
          </div>
        </div>       
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user, auth }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    onBoardingCCM
  } = careprovider;
  const userId = user.userDetails._id;
  const profileOwner = user.profileOwner;
  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    onBoardingCCM,
    userId,
    profileOwner
  };
};

export default connect(mapStateToProps)(OnBoardingCCM);
